'use strict';

var React = require('react');

var SvgFirstOrderMajor = function SvgFirstOrderMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m9.69 5.772-.243.123a1 1 0 1 1-.895-1.79l2-1a.998.998 0 0 1 1.434 1.06l-1 6a1 1 0 1 1-1.973-.33l.677-4.063zm-5.073-.848a.997.997 0 0 1-.324-.217l-1-1a1 1 0 0 1 1.414-1.414l1 1a.999.999 0 0 1-1.09 1.631zm10.766 0a.997.997 0 0 1-.94-.092 1 1 0 0 1-.15-1.54l1-1a1 1 0 1 1 1.414 1.415l-1 1a.996.996 0 0 1-.324.217zm-.09 3.783a1 1 0 0 1 .707-1.707h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-.707-.293zm-11.293.293h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zm-3 8.5v-5.5h2v2h3.5c.775 0 1.388.662 1.926 1.244l.11.12a2 2 0 0 0 2.927-.001l.11-.119h.001c.538-.582 1.151-1.244 1.926-1.244h3.5v-2h2v5.5a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5z"
  }));
};

exports.SvgFirstOrderMajor = SvgFirstOrderMajor;
